import { createElement } from 'react';
import { TreeSelect as OriginTreeSelect } from 'antd';
const TreeSelect = (props) => {
    return createElement(OriginTreeSelect, { ...props });
};
export default TreeSelect;
